import cs from 'classnames';
import type { FC } from 'react';
import type { IIconProps, IIconSizeTypes } from '@/Module/Icon/Model';
const sizeBoxes: Record<IIconSizeTypes, string> = {
  extraSmall: 'w-3 h-3',
  smaller: 'w-4 h-4',
  small: 'w-6 h-6',
  middle: 'w-12 h-12',
  large: 'w-16 h-16',
  extraLarge: 'w-[88px] h-[88px]'
};
export const BaseIcon: FC<IIconProps> = ({
  size,
  children,
  className
}) => {
  return <span className={cs('inline-flex items-center justify-center ui__icon', sizeBoxes[size!], className)} data-sentry-component="BaseIcon" data-sentry-source-file="index.tsx">{children}</span>;
};
BaseIcon.defaultProps = {
  size: 'middle'
};